export default __webpack_public_path__ + "static/media/mobile-upload-btn.b5039032.png";